export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/monitoringChat.worker.653a7b5b.worker.js");
}
